// Thin gtag wrapper — GA4 is loaded from index.html on every page.
// Safe to call before gtag exists (it will simply no-op).

export const GA_MEASUREMENT_ID = "G-CZT0H289NX";

export function trackEvent(name, params = {}) {
  try {
    if (typeof window === "undefined") return;
    // eslint-disable-next-line no-undef
    const fn = window.gtag;
    if (typeof fn === "function") {
      fn("event", name, params);
    }
  } catch (e) {
    // never throw from analytics
  }
}

export function trackSignup(method) {
  trackEvent("sign_up", { method });
  trackEvent("signup", { method });
}

export function trackPolicyUploaded({ upload_id, insurer, clarity_score } = {}) {
  // De-dupe: only fire once per upload id per browser.
  try {
    if (upload_id) {
      const key = `kyp_ga_uploaded_${upload_id}`;
      if (typeof localStorage !== "undefined" && localStorage.getItem(key)) {
        return;
      }
      if (typeof localStorage !== "undefined") localStorage.setItem(key, "1");
    }
  } catch (_) {}
  trackEvent("policy_uploaded", {
    upload_id,
    insurer: insurer || "unknown",
    clarity_score: clarity_score ?? null,
  });
}
